import requests from "./httpService";

// const adminInfo = localStorage.getItem("adminInfo")
//   ? JSON.parse(localStorage.getItem("adminInfo"))
//   : null;
// const id_employee = adminInfo?.id ? adminInfo.id : 0;
const BillApprovalServices = {
  billapprovalList: async (body) => {
    return requests.post(
      `/billPayment/approval-list`, body);
  },

  approvebill:async(id,body)=>{
    return requests.put(`billPayment/approve/${id}`,body)
  },

  checkoutstanding: async (vendor_id) => {
    return requests.get(`/billPayment/check-outstanding/${vendor_id}`);
  },

  // adjustOutstanding: async (body) => {
  //   return requests.put(`/billPayment/adjust-outstanding`, body);
  // },
};

export default BillApprovalServices;
